import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-status-error',
  standalone: true,
  imports: [],
  templateUrl: './status-error.component.html',
  styleUrl: './status-error.component.sass',
})
export class StatusErrorComponent implements OnInit {
  statusCode: number
  message: string

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.statusCode = +params['statusCode']
      this.setMessage()
    })
  }

  setMessage(): void {
    switch (this.statusCode) {
      case 401:
        this.message = 'Unauthorized: You do not have permission to view this page.'
        break
      case 404:
        this.message = 'Not Found: The requested resource could not be found.'
        break
      case 500:
        this.message = 'Server Error: An error occurred on the server.'
        break
      default:
        this.message = `Error ${this.statusCode}: An unexpected error occurred.`
        break
    }
  }
}
